import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import {
  c1,
  c3,
  c4,
  c5,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-gen-atabswiping-component",
  templateUrl: "./gen-atabswiping-component.component.html",
  styleUrls: ["./gen-atabswiping-component.component.scss"],
})
export class GenAtabswipingComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private lightbox: Lightbox,
  ) {}

  @Input() page_id: string;
  @Input() tabData: Tab;

  page: any;
  c4_value: string;
  c5_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab: string = c3.SINGLE;

  appHome: any = {
    id: "home",
    app: { tabs: { tabs: [] }, default: { feed: {} } },
  };

  ngOnInit() {
    this.albums = [
      {
        id: c5.WIDE,
        src: "../../../assets/images/small/img-3-anavtab.jpg",
        caption: " Icon and Title",
      },
      {
        id: c5.STANDARD,
        src: "../../../assets/images/small/img-4-anavtab.jpg",
        caption: "Icon or Title",
      },
    ];

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.page.id == this.page_id
        ) {
          this.c3_value = localStorage.getItem("mode")[2];
          this.c5_value = localStorage.getItem("mode")[4];
        }
      },
    );

    const appHome = this.indexDBService.getItem("app", "home");
    if (appHome) {
      appHome.onsuccess = (event) => {
        if (appHome.result) {
          this.appHome = appHome.result;
        }
      };
    }
  }
  open(index: number): void {
    // open lightbox
    this.c5_value = this.albums[index].id;
    let modes = [{ id: c5.ID, value: this.c5_value }];
    this.mdw.changeMobileTheme(modes);
    this.mdw.changeTab(
      { tab: this.tabData },
      localStorage.getItem("mode"),
      true,
    );
  }

  toggle(status) {
    const appHome = this.indexDBService.getItem("app", "home");
    if (appHome) {
      appHome.onsuccess = (event) => {
        if (appHome.result) {
          this.appHome = appHome.result;
          this.appHome.app.tabs["tab_swipe_off"] = status ? 1 : 0;
          this.appHomeUpdate(this.appHome);
        }
      };
    }
  }

  appHomeUpdate(appHome) {
    if (appHome) {
      this.indexDBService.updateItem("app", appHome);
    }
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
